module.exports = __webpack_public_path__ + "static/media/checkbox.18bd0450.svg";